import { useEffect, useRef, memo } from "react";
import Dygraph from "dygraphs";
import moment from "moment";

const months = [
  { number: "01", name: "Янв" },
  { number: "02", name: "Фев" },
  { number: "03", name: "Мар" },
  { number: "04", name: "Апр" },
  { number: "05", name: "Май" },
  { number: "06", name: "Июн" },
  { number: "07", name: "Июл" },
  { number: "08", name: "Авг" },
  { number: "09", name: "Сен" },
  { number: "10", name: "Окт" },
  { number: "11", name: "Ноя" },
  { number: "12", name: "Дек" },
];

function Chart({ data, setSelectedIndex, mintemp, maxtemp }) {
  const graphEl = useRef(null);

  function getNumber() {
    let sum = 0;
    let result = 0;

    if (mintemp >= 0 && maxtemp >= 0) {
      sum = maxtemp - mintemp;
    } else if (mintemp < 0 && maxtemp >= 0) {
      sum = maxtemp - mintemp;
    } else {
      sum = -mintemp - -maxtemp;
    }

    if (sum <= 2) {
      result = 1;
    } else {
      result = Number(Math.floor(sum / 2));
    }

    return result * 2;
  }

  const fullPresets = {
    colors: ["#3183be"],
    height: 700,
    highlightSeriesOpts: { strokeWidth: 2 },
    visibility: [true, true],
    valueRange: [mintemp - getNumber(), maxtemp + getNumber()],
    labels: ["X", "Температура"],
    legend: "always",
    showRangeSelector: true,
    pointClickCallback: function (e, pt) {
      setSelectedIndex(pt.idx);
    },
    axes: {
      y: {
        axisLabelFontSize: 13,
      },
      x: {
        axisLabelFontSize: 13,
        axisLabelFormatter: function (d, gran) {
          let hours = moment(d).hours();

          if (hours === 0) {
            let month_name = "";
            let month = moment(d).format("MM");
            let day = moment(d).format("DD");

            months.forEach((item) => {
              if (item.number === month) {
                month_name = item.name;
              }
            });
            return `${day} ${month_name}`;
          } else {
            return moment(d).format("HH:mm");
          }
        },
      },
    },
  };

  useEffect(() => {
    if (!!data) {
      new Dygraph(graphEl.current, data, fullPresets);
    }
  }, [data]);

  return (
    <div className="chat-view">
      <div className="chact-block" ref={graphEl} />

      <span className="span-label">Температура</span>
    </div>
  );
}

export default memo(Chart);
